import { infiniteLoading } from '../lib/customEvents';

export default {
  bind(el, binding, vnode) {
    let ev = el.event;

    ev = e => {
      const { handler } = binding.value;
      const rect = el.getBoundingClientRect();
      const viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight
      );

      if (!(rect.bottom < 0 || rect.top - viewHeight >= 0)) {
        vnode.context[handler]();
      }
    };

    document.addEventListener('load', ev);
    document.addEventListener('scroll', ev);
    document.addEventListener('infiniteLoading', ev);
  },
  unbind(el) {
    document.removeEventListener('load', el.event);
    document.removeEventListener('scroll', el.event);
    document.removeEventListener('infiniteLoading', el.event);
  },
};
